document.addEventListener('DOMContentLoaded' , function(){
      
      const chatButton = document.querySelector('.text-with-icons__item:nth-of-type(2)');
     chatButton.addEventListener('click' , function(){
         if (window.tidioChatApi) {
         window.tidioChatApi.open();
        console.log('clicked')
        }
     })
      
    
})